import { KYDScope } from "@common/interfaces/ICognito";

const ShowIfHasPermission = ({
  permissions = [],
  checkFor,
  children,
}: {
  permissions: KYDScope[];
  checkFor: string | string[];
  children: JSX.Element;
}) => {
  const checkValues = Array.isArray(checkFor) ? checkFor : [checkFor];
  if (checkValues.some((val) => permissions.includes(val as KYDScope))) {
    return children;
  }

  return null;
};

export default ShowIfHasPermission;
